import * as React from "react";
import MultipleSelect from "../../../GenericComponents/MUltipleSelect";
import styles from "./styles.module.sass";
import { RouteComponentProps } from "react-router";
import { InjectedTranslateProps, translate } from "react-i18next";
import * as Strings from "../../../../../i18n/strings/MultipleSelect";
import { useSelect } from "../../../../../hooks/useSelect";
import { IBranch, PickupStatus } from "../../../../../types/shared";
import { clearPreviousState } from "../../../redux-store/actions/pickupBranchesActions";
import { useDispatch } from "react-redux";
import { useUserAccess } from "../../../../../Components/AuthenticatedRoutes";

export const selectedBranchesMap = (branches: IBranch[]) => {
  return branches
    .filter((b) => !b.deleted && !b.call_center)
    .reduce(
    (acc, next) => {
      const pickupScheduled = next.scheduled_services?.pickup;
      const deliveryScheduled = next.scheduled_services?.delivery;
      const driveThruScheduled = next.scheduled_services?.drive_thru;

      const branchIsEnabled =
        next.pickup_status &&
        next.pickup_status !== PickupStatus.service_disabled &&
        !pickupScheduled;
      const deliveryIsEnabled =
        next.delivery_status &&
        next.delivery_status !== PickupStatus.service_disabled &&
        !deliveryScheduled;
      const driveThruIsEnabled = next.drive_thru_status &&
        next.drive_thru_status !== PickupStatus.service_disabled &&
        !driveThruScheduled;
      return {
        ...acc,
        pickup_branch_ids: {
          ...acc.pickup_branch_ids,
          [next.id]: branchIsEnabled,
        },
        delivery_branch_ids: {
          ...acc.delivery_branch_ids,
          [next.id]: deliveryIsEnabled,
        },
        drive_thru_branch_ids: {
          ...acc.drive_thru_branch_ids,
          [next.id]: driveThruIsEnabled,
        }
      };
    },
    { pickup_branch_ids: {}, delivery_branch_ids: {}, drive_thru_branch_ids: {} }
  );
};

const SelectedBranches: React.FC<
  RouteComponentProps & InjectedTranslateProps
> = ({ t }) => {
  const dispatch = useDispatch();
  const { demoMode } = useUserAccess();
  const { allBranches: branches, loaded } = useSelect(
    (state) => state.branchesReducer
  );

  const items = React.useMemo(
    () =>
      branches
        .filter((b) => !b.call_center)
        .map((item) => ({
          name: item.name,
          value: item.id,
          pos_vendor: item.pos_vendor,
          pos_name: item.pos_name,
          style: demoMode ? { filter: 'blur(5px)', pointerEvents: 'none' as const } : undefined,
        })),
    [branches, demoMode]
  );

  const { status: submitOrderingBranches } = useSelect(
    (state) => state.submitPickupBranchesReducer
  );

  React.useEffect(() => {
    if (submitOrderingBranches === "success") {
      dispatch(clearPreviousState());
    }
  }, [submitOrderingBranches, dispatch]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.btnWrapper}>
        <div className={styles.header}>
          <span className={styles.branchesCount}>
            {t(Strings.branches)} ({items.length})
          </span>
          <p>{t(Strings.description)}</p>
        </div>
      </div>
      <form className={styles.main}>
        <MultipleSelect items={items} />
      </form>
    </div>
  );
};

export default translate("MultipleSelect")(SelectedBranches);
